const TAIPEI_TIME_ZONE = "Asia/Taipei";

function taipeiParts(date: Date) {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: TAIPEI_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hourCycle: "h23"
  });
  return Object.fromEntries(formatter.formatToParts(date).map((part) => [part.type, part.value]));
}

export function toTaipeiDateHour(value: string | Date): { viewDate: string; viewHour: string } {
  const date = typeof value === "string" ? new Date(value) : value;
  const parts = taipeiParts(date);
  const viewDate = `${parts.year}-${parts.month}-${parts.day}`;
  return {
    viewDate,
    viewHour: `${viewDate}T${parts.hour}:00:00+08:00`
  };
}

export function addDays(dateString: string, days: number): string {
  const date = new Date(`${dateString}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function taipeiToday(now = new Date()): string {
  return toTaipeiDateHour(now).viewDate;
}

export function taipeiHour(now = new Date()): string {
  return toTaipeiDateHour(now).viewHour;
}
